/**
 * @copyright 2023 Chris Zuber <admin@kernvalley.us>
 */
export const REFERRER_POLICY = 'strict-origin-when-cross-origin';
